import ApiService from '@services/api.service';
import { Notify } from 'quasar';

export const etudiant = {
  state: {
    etudiants: [],
    etudiant: null,
    candidats: [],
  },
  mutations: {
    setEtudiants(state, etudiants) {
      state.etudiants = etudiants
    },
    setEtudiant(state, etudiant) {
      state.etudiant = etudiant
    },
    setCandidats(state, candidats){
      state.candidats = candidats;
    },
    ADD_STAGIAIRE(state, stagiaire) {
      state.etudiants.push(stagiaire)
    },
    UPDATE_STAGIAIRE(state, updatedStagiaire) {
      const index = state.etudiants.findIndex(
        (e) => e.id === updatedStagiaire.id
      )
      if (index !== -1) {
        state.etudiants.splice(index, 1, updatedStagiaire)
      }
    },
    REMOVE_STAGIAIRE(state, stagiaireId) {
      state.etudiants = state.etudiants.filter((e) => e.id !== stagiaireId)
    }
  },
  actions: {
    /**
     * Récupération générique des stagiaires pour le planning.
     * Gère le filtrage via des paramètres.
     */
    async fetchStagiaires({ commit }, params = {}) {
      try {
        const response = await ApiService.getRequest('stagiaires', params)
        commit('setEtudiants', response.data['hydra:member'])
        return response.data['hydra:member']
      } catch (error) {
        console.error('Erreur lors de la récupération des bénéficiaires:', error)
        Notify.create({
          message:
            "Une erreur s'est produite lors de la récupération des bénéficiaires.",
          color: 'red'
        })
        throw error
      }
    },

    /**
     * Récupère la liste des étudiants légère (id, nom, prénom)
     */
    async fetchLightListEtudiant(context){
      try{
        const response =  await ApiService.getRequest('light-list-etudiants');
        context.commit('setEtudiants', response.data);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        });
      }
    },

    /* ETUDIANTS (GET) */
    async fecthEtudiant(context, idStagiaire) {
      try {
        return await ApiService.getRequest(`/etudiants/${idStagiaire}`).then(
          (response) => {
            this.commit('setEtudiant', response.data)
            return response.data
          }
        )
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },

    async fetchEtudiantApprentis(){
      try{
        const response = await ApiService.getRequest('/get_stagiaire_apprentis');
        return Number(response.data) || 0
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite lors de la récupération des données",
          color: 'red',
        })
        return 0
      }
    },

    async fecthEtudiantsFiltres(context, url){
      try{
        const response = await ApiService.getRequest(url);
        context.commit("setEtudiants", response.data['hydra:member']);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    },

    fetchEtudiants(context, filters) {
      if (filters !== undefined) {
        return ApiService.getRequest(
          '/stagaires_pedagogie_light_list&' + filters
        )
          .then((response) => {
            context.commit('setEtudiants', response.data['hydra:member'])
          })
          .catch((error) => {
            console.error(error)
          })
      } else {
        return ApiService.getRequest('/stagaires_pedagogie_light_list')
          .then((response) => {
            context.commit('setEtudiants', response.data['hydra:member'])
          })
          .catch((error) => {
            console.error(error)
          })
      }
    },

    fetchEtudiantsByAntennaId(context, antenneId) {
      return ApiService.getRequest(
        `/stagaires_pedagogie_light_list?antenne=${antenneId}`
      )
        .then((response) => {
          context.commit('setEtudiants', response.data['hydra:member'])
          return response.data['hydra:member']
        })
        .catch((error) => {
          console.error(error)
          Notify.create({
            message:
              "Une erreur s'est produite lors de la récupération des données",
            color: 'red'
          })
        })
    },

    fetchEtudiantsByFilter(context, filters) {
      //todo:mettre la possibilité d'avoir plusieurs filtres
      //si ${filters} retourne [object, object]
      return ApiService.getRequest(
        `/stagaires_pedagogie_light_list?${Object.keys(
          filters
        )}=${Object.values(filters)}`
      )
        .then((response) => {
          context.commit('setEtudiants', response.data['hydra:member'])
          return response.data['hydra:member']
        })
        .catch((error) => {
          console.error(error)
        })
    },

    async fetchPifEtudiantById(context, idEtudiant) {
      return new Promise((resolve, reject) => {
        ApiService.getRequest(`/stagiaires_plan_individuel/${idEtudiant}`)
          .then((response) => {
            context.commit('setEtudiant', response.data)
            resolve()
          })
          .catch((error) => {
            console.error(error)
            Notify.create({
              message: "Une erreur s'est produite",
              color: 'red'
            })
            reject(error)
          })
      })
    },

    async fetchEvaluationEtudiantById(context, idEtudiant) {
      return new Promise((resolve, reject) => {
        ApiService.getRequest(`/stagiaires_evaluations/${idEtudiant}`)
          .then((response) => {
            context.commit('setEtudiant', response.data)
            resolve()
          })
          .catch((error) => {
            console.error(error)
            Notify.create({
              message: "Une erreur s'est produite",
              color: 'red'
            })
            reject(error)
          })
      })
    },

    async fetchEvaluationsCPSEtudiantById(context, idEtudiant) {
      return new Promise((resolve, reject) => {
        ApiService.getRequest(`/stagiaires_evaluations/${idEtudiant}`)
          .then((response) => {
            context.commit('setEtudiant', response.data)
            resolve()
          })
          .catch((error) => {
            console.error(error)
            Notify.create({
              message: "Une erreur s'est produite",
              color: 'red'
            })
            reject(error)
          })
      })
    },

    async fetchEvaluationsEtudiantByAntenne(context, antenneList) {
      try {
        const antennes = Array.isArray(antenneList) ? antenneList : [antenneList]

        // API Platform attend antenne[]=/api/antennes/1&antenne[]=/api/antennes/2
        const queryString = antennes
          .map((id) => `antenne[]=${encodeURIComponent(id)}`)
          .join('&')

        const response = await ApiService.getRequest(
          `/stagaires_pedagogie_light_list?${queryString}`
        )

        if (response.data?.['hydra:member']) {
          context.commit('setEtudiants', response.data['hydra:member'])
        }
      } catch (error) {
        console.error(error)
        Notify.create({
          message: 'Erreur lors du chargement des bénéficiaires',
          color: 'red'
        })
        throw error
      }
    },

    // Récupére les bénéficiaires en fonction de leur date d'entree
    async fetchEtudiantByDateEntree(context, data) {
      return await ApiService.getRequest(data.url, data.dateEntree)
        .then((response) => {
          context.commit('setEtudiants', response.data['hydra:member'])
        })
        .catch((error) => {
          console.error(error)
          Notify.create({
            message:
              "Une erreur s'est produite lors de la récupération des données",
            color: 'red'
          })
        })
    },
    //Récupere les etudiants actif type = 1 && etat = 0
    async fetchEtudiantsActifs(context) {
      return await ApiService.getRequest(`stagiaires?etat=0&type=1`)
        .then((response) => {
          context.commit('setEtudiants', response.data['hydra:member'])
        })
        .catch((error) => {
          console.error(error)
          Notify.create({
            message:
              "Une erreur s'est produite lors de la récupération des données",
            color: 'red'
          })
        })
    },
    //Récupere les etudiants qui sont sortie pour le POST PARCOURS
    fetchEtudiantsSortie(context, antenne) {
      return ApiService.getRequest('stagiaires_sortis?etat=1', {antenne: antenne})
        .then((response) => {
          context.commit('setEtudiants', response.data['hydra:member'])
        })
        .catch((error) => {
          console.error(error)
          Notify.create({
            message: "Une erreur s'est produite",
            color: 'red'
          })
        })
    },

    //Récupere les bénéficiaires sortie en fonction de de l'antenne pour le POST PARCOURS
    fetchEtudiantSortieByAntenne(context, idAntenne) {
      return ApiService.getRequest('stagiaires_sortis?etat=1', {
        antenne: idAntenne
      })
        .then((response) => {
          context.commit('setEtudiants', response.data['hydra:member'])
        })
        .catch((error) => {
          console.error(error)
          Notify.create({
            message: "Une erreur s'est produite",
            color: 'red'
          })
        })
    },

    //Récupere les etudiants qui sont archivé pour le POST PARCOURS
    fetchEtudiantsArchived(context) {
      return ApiService.getRequest('stagiaires_sortis?etat=2')
        .then((response) => {
          context.commit('setEtudiants', response.data['hydra:member'])
        })
        .catch((error) => {
          console.error(error)
          Notify.create({
            message: "Une erreur s'est produite",
            color: 'red'
          })
        })
    },

    //Récupere les 5 derniers candidats en passant par le back
    async fetchCandidats(context){
      try{
        const response = await ApiService.getRequest('get_candidats_recents');
        context.commit('setCandidats', response.data.candidats);
      }catch (e) {
        console.error(e);
        Notify.create({
          message: "Une erreur est survenue",
          color: 'red',
        })
      }
    },

    //Ajoute l'etudiant
    async ajouteEtudiant(context, data) {
      try {
        const response = await ApiService.postRequest('etudiants', data)
        context.commit('setEtudiant', response.data);
        if (data.type === 0) {
          Notify.create({
            message: 'Candidat Ajouté avec succès',
            color: 'green'
          })
        } else {
          Notify.create({
            message: 'Bénéficiaire Ajouté avec succès',
            color: 'green'
          })
        }
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout",
          color: 'red'
        })
      }
    },
    /* CRUD ETUDIANTS (POST/PATCH/DELETE) */
    async editEtudiant({ state }, formData) {
      try {
        const response = await ApiService.patchRequest(
          `${formData.uri}`,
          formData
        )
        if (response.status === 200) {
          this.commit('setEtudiant', response.data)
          Notify.create({
            message: "La convention de le bénéficiaire a été modifiée avec succès",
            color: 'green'
          })
          return Promise.resolve()
        }
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },
    //Modifie l'etat de le bénéficiaire
    async editEtudiantEtat(context, data) {
      try {
        const response = await ApiService.postRequest(data.url, {
          etat: data.etat
        })
        context.commit('setEtudiant', response.data)
        Notify.create({
          message: 'La modification a bien été effectuée',
          color: 'green'
        })
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },
    // Modifie le stagiaire de façon à le retirer de la session
    async editEtudiantSession(context, data) {
      try {
        const response = await ApiService.patchRequest(data.url, {
          diplome_session: data.diplome_session
        })
        context.commit('setEtudiant', response.data)

        Notify.create({
          message: 'Le bénéficiaire a bien été retiré de la session',
          color: 'green'
        })
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite lors de la modification",
          color: 'red'
        })
      }
    },
    /*Modifie le bénéficiaire lorsqu'il passe en état de sortie,
      + lors de la modification d'un contrat en apprentissage
      + Bascule nouveau parcours
    */
    async updateEtudiantStatus(context, data) {
      try {
        const response = await ApiService.patchRequest(data.url, data.datas)
        context.commit('setEtudiant', response.data)
        Notify.create({
            message: "Le bénéficiaire a été mofié avec succès",
          color: 'green'
        })
      } catch (error) {
        console.error(error)
        Notify.create({
          message:
            "Une erreur s'est produite lors de la modification de le bénéficiaire",
          color: 'red'
        })
      }
    },

    async updateBasculeEtudiant(context, data) {
      try {
        const response = await ApiService.postRequest(data.url, data.stagiaire)
        context.commit('setEtudiant', response.data)
        Notify.create({
          message: "Le bénéficiaire a bien été basculé",
          color: 'green'
        })
      } catch (error) {
        console.error(error)
        Notify.create({
          message:
            "Une erreur s'est produite lors de la modification de le bénéficiaire",
          color: 'red'
        })
      }
    },

    async updateEtudiantSession(context, data){
      try{
        const response = ApiService.getRequest(`update_stagiaire_session/${data}`);
        context.commit("setEtudiant", response.data);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    },

    // Export CSV
    async exportEtudiantCSV(context, url) {
      try {
        await ApiService.downloadRequest({ url: url, method: 'GET' })
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "une erreur s'est produite lors de l'export des données",
          color: 'red'
        })
      }
    }
  },
  getters: {
    getEtudiants(state) {
      return state.etudiants
    },
    getEtudiant(state) {
      return state.etudiant
    },
    getCandidats(state){
      return state.candidats
    },
    getStagiaireById: (state) => (id) => {
      return state.etudiants.find((e) => e.id === id || e['@id'] === id)
    },
    getStagiairesByAntenne: (state) => (antenneIri) => {
      return state.etudiants.filter(
        (e) =>
          e.antenne &&
          (e.antenne === antenneIri || e.antenne['@id'] === antenneIri)
      )
    }
  }
}
